import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const CardWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  gap: "24px",
  "@media screen and (max-width: 360px)": {
    gap: "16px",
  },
}));

export const Card = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  alignItems: "flex-end",

  "@media screen and (max-width: 360px)": {
    borderRight: "1px solid #E4E7EC",
    paddingRight: "16px",
    alignItems: "flex-start",
    "&:last-child": {
      border: 0,
      paddingRight: 0,
    },
  },
}));

export const Title = styled("span")(() => ({
  color: colors.gray500,
  font: "600 12px Manrope",
  lineHeight: "16px",
  letterSpacing: "0.5px",

  "&.shortText": {
    display: "none",
  },

  "@media screen and (max-width: 360px)": {
    "&.shortText": {
      display: "inline-block",
    },
    "&.longText": {
      display: "none",
    },
  },
}));

export const Value = styled("span")(() => ({
  color: colors.gray600,
  font: "600 16px Manrope",
  lineHeight: "24px",
  letterSpacing: "0.15px",
}));
